/* TRLab native tracking text adapter v13. Read-only adapter for Track123's anonymous-query response. */
(function (factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else api.start(window, document);
})(function () {
  'use strict';
  var DAY = 86400000;
  var PREPARATION = [
    { key: 'designer', title: 'Designer preparation', hours: 23, copy: 'Our designer partners help prepare your items for dispatch. Thank you for supporting independent design.' },
    { key: 'warehouse', title: 'Warehouse preparation', hours: 45, copy: 'Our warehouse team prepares your items with careful packing and protective packaging to help keep them safe in transit.' }
  ];
  var NODE_DETAILS = {
    ordered: 'We’ve received your order. Your order will ship within 48 hours. Some special orders may need about one additional day for preparation. Thank you for your patience.',
    label: 'Your shipping label has been created. Tracking updates will appear here once the carrier scans your package.'
  };
  var ENDPOINT = '/shopify/api/order/anonymous-query';
  var FIRST_MILE = /\b(?:4PX[0-9A-Z]+|UL[0-9A-Z]+YP|YT\d{8,})\b/gi;
  var EXCEPTION = /\b(?:exception|delay(?:ed)?|failed|failure|return(?:ed|ing)?|cancel(?:led|ed)?|damaged?|lost|unable|unsuccessful|unclaimed|refused|detained|held|hold|address issue|delivery attempt)\b/i;
  var TERMINAL = /^(delivered|cancelled|canceled|returned|returned_to_sender)$/i;
  var ZONES = {
    'America/New_York': 'CT DE DC GA ME MD MA NH NJ NY NC OH PA RI SC VT VA WV',
    'America/Chicago': 'AL AR IL IA LA MN MS MO WI',
    'America/Denver': 'CO MT NM UT WY',
    'America/Los_Angeles': 'CA WA',
    'Pacific/Honolulu': 'HI'
  };

  function str(value) { return typeof value === 'string' ? value : ''; }
  function list(value) { return Array.isArray(value) ? value : []; }
  function clean(value) {
    return str(value)
      // Remove the contact block before replacing carrier names, including the GOFO email suffix.
      .replace(/(?:For Delivery Issues\s*&\s*Tracking Support,?\s*)?\b(?:Contact|Call)\s+(?:GOFO|SpeedX|UniUni|SwiftX|YWE)\b(?:\s+at)?\s*:?\s*(?:\+?\d[\d\s().-]{7,}\d)?(?:\s+or\s+[\w.+-]+@(?:[\w-]+\.)*(?:gofo|speedx|uniuni|swiftx)\.[a-z]{2,})?/gi, '')
      .replace(/\b[\w.+-]+@(?:[\w-]+\.)*(?:gofo|speedx|uniuni|swiftx)\.[a-z]{2,}\b/gi, '')
      .replace(/\+\d[\d\s().-]{7,}\d/g, '')
      .replace(FIRST_MILE, '')
      .replace(/Yanwen\s+Pickup\s+Scan/gi, 'Picked up by carrier')
      .replace(/Yanwen\s+facility/gi, 'Fulfillment center')
      .replace(/Port of departure/gi, 'Origin airport')
      .replace(/\b(?:4PX|Yanwen(?:\s*Express)?|YunExpress|Yun\s*Express|GOFO|SpeedX|UniUni|SwiftX(?:\s*Express)?|YWE)\b/gi, 'Carrier')
      .replace(/\b(?:Nancheng|Dongguan|Shenzhen|Guangzhou)\b/gi, 'Fulfillment center')
      .replace(/\b(?:Mainland\s+China|Hong\s*Kong|China|CN|HK)\b/gi, '')
      .replace(/[\u3400-\u9fff]+/g, '')
      .replace(/\s+/g, ' ').replace(/^[\s,;:.-]+|[\s,;:-]+$/g, '').trim();
  }
  function instant(value, utc) {
    var text = str(value).trim();
    if (!text) return null;
    // Never interpret a carrier-local, timezone-less timestamp in the visitor's timezone.
    if (!/(?:Z|[+-]\d{2}:?\d{2})$/i.test(text)) {
      if (!utc) return null;
      text = text.replace(' ', 'T') + 'Z';
    }
    var ms = Date.parse(text);
    return Number.isFinite(ms) ? ms : null;
  }
  function zoneFor(raw) {
    var supplied = str(raw.destination_time_zone);
    if (supplied) {
      try { new Intl.DateTimeFormat('en-US', { timeZone: supplied }).format(); return supplied; } catch (_) { /* unknown zone */ }
    }
    if (raw.shipping_country_code !== 'US') return '';
    var state = str(raw.shipping_province_code).toUpperCase();
    return Object.keys(ZONES).find(function (zone) { return ZONES[zone].split(' ').indexOf(state) !== -1; }) || '';
  }
  function dateOnly(value) {
    var match = str(value).match(/^(\d{4})-(\d{2})-(\d{2})(?:$|[ T])/);
    if (!match) return null;
    var ms = Date.UTC(+match[1], +match[2] - 1, +match[3]);
    return new Date(ms).toISOString().slice(0, 10) === match[0].slice(0, 10) ? ms : null;
  }
  function classify(text) {
    if (EXCEPTION.test(text)) return 'exception';
    if (/label (?:has been )?created|shipping order created|(?:shipment|parcel|electronic) information received|pre[- ]shipment/i.test(text)) return 'label';
    if (/port of destination.*arrival|arrival to (?:the )?destination airport|arrived (?:at|in) (?:the )?destination (?:country|airport)|arrived in (?:the )?(?:US\b|United States)/i.test(text)) return 'arrived';
    if (/port of departure.*departure|departure from (?:the )?(?:original|origin) airport|international flight has departed|departed origin/i.test(text)) return 'departed';
    if (/shipment picked up|picked up by (?:the )?carrier|yanwen pickup scan|^picked up[.!]?$/i.test(text)) return 'picked';
    return '';
  }
  function preparationKind(value) {
    var text = str(value).trim();
    if (/^Designer preparation$|^Our designer partners help prepare your items\b/i.test(text)) return 'designer';
    if (/^Warehouse preparation$|^Our warehouse team prepares your items\b/i.test(text)) return 'warehouse';
    return '';
  }
  function preparationCopy(kind, value) {
    // 仓库去掉重复备货例外；准备节点移除耐心致谢，仅 Ordered 保留一次。
    if (kind === 'warehouse') value = value.replace(/\s*Some special orders (?:need|may require) additional preparation time\.\s*/i, ' ');
    return value.replace(/\s*Thank you for your\s+patience[.!]?/gi, '').trim();
  }
  function orderInstant(value, offset) {
    // 店铺无时区时间只在明确提供偏移时换算，拒绝纯日期及非法时刻。
    if (dateOnly(value) === null || !/^\d{4}-\d{2}-\d{2}[ T](?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})?$/i.test(str(value))) return null;
    var explicit = instant(value, false);
    if (explicit !== null) return explicit;
    return offset === null ? null : instant(value, true) - offset * 3600000;
  }
  function preparationPlan(order, pack, now) {
    if (!order || !pack || order.cancelled || pack.status === 'cancelled' || order.createdAt == null || order.offset === null || order.createdAt > now) return null;
    var labels = pack.events.filter(function (e) { return e.kind === 'label' && !e.tail; });
    // 尾程面单不是首次出单依据；时间不足时保留后台，不能猜测或借访问时间补历史。
    if (labels.some(function (e) { return e.utc === null || e.utc <= order.createdAt || e.utc > now; })) return null;
    var labelAt = labels.length ? Math.min.apply(null, labels.map(function (e) { return e.utc; })) : null;
    if (labelAt === null && (pack.hasLabel || !/^(?:|ordered|pending|unfulfilled|not_found|info_received)$/.test(pack.status) || pack.events.some(function (e) { return !preparationKind(e.detail); }))) return null;
    var span = labelAt === null ? null : labelAt - order.createdAt;
    // 提前出单时按 23:22:1 分配下单至面单的间隔，保证两条准备记录严格在面单前。
    return PREPARATION.map(function (stage) {
      var at = order.createdAt + (span !== null && span <= 45 * 3600000 ? Math.floor(span * stage.hours / 46) : stage.hours * 3600000);
      return { key: stage.key, title: stage.title, copy: stage.copy, at: at };
    }).filter(function (stage) { return stage.at <= now; });
  }
  function event(raw, tail) {
    var detail = str(raw.event_detail);
    var location = str(raw.event_location);
    return {
      detail: clean(detail) || 'Carrier update',
      location: /\b(?:Nancheng|Dongguan|Shenzhen|Guangzhou|China|CN|Hong\s*Kong|HK)\b/i.test(location) ? '' : clean(location),
      local: str(raw.event_time),
      utc: instant(raw.event_time_u_t_c || raw.event_time_utc, true) ?? instant(raw.event_time, false),
      kind: classify(detail) || (/\binternational flight has arrived\b/i.test(detail) && /\b(?:US|USA|United States)\b/i.test(location) ? 'arrived' : ''), tail: tail,
      domestic: /\b(?:US|USA|United States)\b/i.test(location) &&
        /arriv|receiv|process|depart|deliver|warehouse|facility/i.test(detail) && classify(detail) !== 'label'
    };
  }
  // 用原事件文字与原时间匹配；同文案多条且无法区分时保留原日期，不错配扫描。
  function timeKey(value) {
    var iso = str(value).match(/^\d{4}-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
    if (iso) return [+iso[1], +iso[2], +iso[3], +iso[4]].join(':');
    var native = str(value).match(/^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s+(\d{1,2})(?:,?\s+\d{4})?\s+(\d{1,2}):(\d{2})(?::\d{2})?\s*(am|pm)?$/i);
    if (!native) return '';
    var hour = +native[3];
    if (native[5]) hour = hour % 12 + (native[5].toLowerCase() === 'pm' ? 12 : 0);
    return ['jan feb mar apr may jun jul aug sep oct nov dec'.split(' ').indexOf(native[1].toLowerCase()) + 1, +native[2], hour, +native[4]].join(':');
  }
  function matchEvent(pack, description, originalTime) {
    if (!pack) return null;
    var candidates = pack.events.filter(function (e) { return clean(description).includes(e.detail); });
    var key = timeKey(originalTime);
    if (key) candidates = candidates.filter(function (e) { return timeKey(e.local) === key; });
    else if (candidates.length > 1) candidates = [];
    if (!candidates.length || candidates.some(function (e) { return e.utc !== candidates[0].utc; })) return null;
    return candidates[0];
  }
  function normalize(raw) {
    if (!raw || raw.no_query_data || !Array.isArray(raw.order_packages) || !raw.order_packages.length) return null;
    var order = {
      name: clean(raw.order_name), country: str(raw.shipping_country_code),
      zone: zoneFor(raw), created: dateOnly(raw.order_create_at),
      offset: typeof raw.store_utc_offset === 'number' && Math.abs(raw.store_utc_offset) <= 14 ? raw.store_utc_offset : null,
      cancelled: /cancel/i.test(str(raw.status)), packages: []
    };
    order.createdAt = orderInstant(raw.order_create_at, order.offset);
    order.packages = raw.order_packages.map(function (p) {
      var lm = p.last_mile_info || {};
      var courier = p.courier || {};
      var code = str(p.courier_code || courier.courier_code).toLowerCase();
      var lmCode = str(lm.lm_track_no_provider_code).toLowerCase();
      var number = str(lm.lm_track_no).trim();
      if (!number && code === 'usps') { number = str(p.tracking_number).trim(); lmCode = 'usps'; }
      if (!/^[a-z0-9 -]{5,60}$/i.test(number) || /^(?:4PX|UL.*YP$|YT\d)/i.test(number)) number = '';
      var events = list(p.tracking_details).map(function (e) { return event(e, false); });
      list(lm.details).forEach(function (e) {
        var item = event(e, true);
        if (!events.some(function (known) { return known.detail === item.detail && known.utc === item.utc && known.local === item.local; })) events.push(item);
      });
      // Preserve the source order when UTC is missing; do not invent timestamps to sort it.
      if (events.length && events.every(function (e) { return e.utc !== null; })) events.sort(function (a, b) { return b.utc - a.utc; });
      var status = str(p.transit_display_status || p.transit_status).toLowerCase().replace(/\s+/g, '_');
      var times = list(p.tracking_status_list);
      // No references to customer/address objects are retained.
      return {
        status: order.cancelled ? 'cancelled' : status, route: code,
        // 自定义/订单状态为店铺当地时间；物流状态须匹配事件 UTC，不能把承运商当地时间当店铺时间。
        statuses: times.map(function (s) {
          var name = str(s.status_name).toLowerCase();
          var storeTime = /^(ordered|order_ready|designer preparation|warehouse preparation)$/.test(name);
          var matches = events.filter(function (e) { return e.local === s.event_time; });
          var at = storeTime ? orderInstant(s.event_time, order.offset) : instant(s.event_time_u_t_c || s.event_time_utc, true) ?? instant(s.event_time, false);
          if (!storeTime && at === null && matches.length && matches.every(function (e) { return e.utc === matches[0].utc; })) at = matches[0].utc;
          return { name: name, at: at };
        }),
        number: number, usps: lmCode === 'usps', events: events,
        hasLabel: !!p.tracking_number || times.some(function (s) { return s.status_name === 'order_ready' && !!s.event_time; }),
        items: list(p.order_items).map(function (item) { return { title: str(item.title), quantity: Number(item.quantity) || 1 }; })
      };
    });
    return order;
  }
  function timeline(pack, country) {
    var arrival = pack.events.find(function (e) { return e.kind === 'arrived'; });
    var physical = pack.events.filter(function (e) { return e.domestic && e.utc !== null; });
    var arrivalTime = arrival && arrival.utc;
    if (arrivalTime == null && physical.length) arrivalTime = Math.min.apply(null, physical.map(function (e) { return e.utc; }));
    var seen = {};
    // Retain the first occurrence of each origin milestone, not every duplicate scan.
    var first = {};
    pack.events.slice().reverse().forEach(function (e) { if (e.kind && !first[e.kind]) first[e.kind] = e; });
    var visible = pack.events.filter(function (e) {
      if (e.kind === 'exception') return true;
      if (e.kind && first[e.kind] === e) return true;
      if (e.tail && e.kind !== 'label') return true;
      if (e.domestic) return true;
      return arrivalTime != null && e.utc !== null && e.utc >= arrivalTime;
    });
    // Unknown wording must not make an existing shipment look as if it has never been scanned.
    if (!visible.length && pack.events.length) visible = [pack.events[0]];
    return visible.filter(function (e) {
      var key = [e.detail, e.utc === null ? e.local : e.utc].join('|');
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    }).map(function (e) {
      var labels = { label: 'Label created', picked: 'Picked up by carrier', departed: 'Departed origin', arrived: country === 'US' ? 'Arrived in US' : 'Arrived at destination' };
      return Object.assign({}, e, { detail: labels[e.kind] || e.detail });
    });
  }
  function statusLabel(pack, country) {
    var statuses = { delivered: 'Delivered', out_for_delivery: 'Out for delivery', failed_attempt: 'Delivery attempt unsuccessful', exception: 'Delivery update — action may be needed', expired: 'Tracking update overdue', cancelled: 'Order cancelled', returned: 'Returned to sender', returned_to_sender: 'Returned to sender' };
    if (statuses[pack.status]) return statuses[pack.status];
    if (pack.events.some(function (e) { return e.kind === 'arrived'; })) return country === 'US' ? 'Arrived in US' : 'Arrived at destination';
    if (pack.events.some(function (e) { return e.kind === 'picked' || e.kind === 'departed' || e.domestic; })) return 'In transit';
    if (pack.status === 'in_transit' && !pack.events.every(function (e) { return e.kind === 'label'; })) return 'In transit';
    return pack.hasLabel ? 'Label created — awaiting carrier pickup' : 'Preparing your order';
  }
  function estimate(order, pack, now) {
    var ranges = { '4px': [8, 12], yanwen: [9, 14], yunexpress: [8, 14] };
    var range = ranges[pack.route];
    if (order.country !== 'US' || order.created === null || !range || TERMINAL.test(pack.status)) return null;
    var weekend = [0, 6].indexOf(new Date(order.created).getUTCDay()) !== -1 ? 1 : 0;
    var start = order.created + (range[0] + weekend) * DAY;
    var end = order.created + (range[1] + weekend) * DAY;
    var today = order.offset === null ? null : Math.floor((now + order.offset * 3600000) / DAY) * DAY;
    return { start: start, end: end, overdue: today !== null && today > end };
  }
  function stale(pack, now) {
    if (TERMINAL.test(pack.status)) return false;
    var times = pack.events.map(function (e) { return e.utc; }).filter(function (t) { return t !== null; });
    return times.length > 0 && now - Math.max.apply(null, times) > 5 * DAY;
  }
  function eventTime(e, zone) {
    if (e.utc !== null && zone) return new Intl.DateTimeFormat('en-US', { timeZone: zone, month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }).format(e.utc);
    return e.local ? e.local + ' (carrier local time)' : 'Time unavailable';
  }
  function calendar(ms) { return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric' }).format(ms); }
  function preparationDate(ms, offset) { return new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric' }).format(ms + offset * 3600000); }

  function start(win, doc) {
    if (win.__trlabTrackingDisplay) return;
    var script = doc.currentScript;
    if (!script) return;
    var mode = script.dataset.mode || 'preview';
    if (mode === 'off' || (mode !== 'live' && new URLSearchParams(win.location.search).get('trlab_tracking') !== 'preview')) return;
    var active = true, revision = 0, order = null, root = null, observer = null, scheduled = false;
    var originalFetch = win.fetch;
    if (typeof originalFetch !== 'function') return;
    var patches = new Map(), hidden = new Set(), timelineRows = new Set(), notices = [], nodeDetails = new Map(), preparationNodes = new Map(), preparationDates = new Map();
    function restore(keepNodeDetails) {
      if (root) root.removeAttribute('data-trlab-tracking-active');
      patches.forEach(function (patch, node) { if (node.data === patch.value) node.data = patch.original; });
      patches.clear();
      timelineRows.forEach(function (node) { node.removeAttribute('data-trlab-timeline-row'); }); timelineRows.clear();
      hidden.forEach(function (node) { node.removeAttribute('data-trlab-tracking-hidden'); }); hidden.clear();
      notices.forEach(function (node) { node.remove(); }); notices = [];
      if (!keepNodeDetails) {
        nodeDetails.forEach(function (node) { node.remove(); }); nodeDetails.clear();
        preparationNodes.forEach(function (node) { node.remove(); }); preparationNodes.clear();
        preparationDates.forEach(function (node) { node.remove(); }); preparationDates.clear();
      }
    }
    function observe() {
      root = doc.getElementById('track123-app');
      var host = root || doc.getElementById('MainContent') || doc.body;
      if (active && host && observer) observer.observe(host, { childList: true, characterData: true, attributes: true, attributeFilter: ['class'], subtree: true });
    }
    function edit(work) { if (observer) observer.disconnect(); try { work(); } finally { observe(); } }
    function clear() { edit(function () { restore(); order = null; }); }
    function hide(node) { if (node) { node.setAttribute('data-trlab-tracking-hidden', 'true'); hidden.add(node); } }
    // Preserve React's elements and text nodes, including existing links and event handlers.
    function text(node, value) {
      if (!node || node.textContent === value) return;
      var walker = doc.createTreeWalker(node, 4), child, first = true;
      while ((child = walker.nextNode())) {
        var next = first ? value : ''; first = false;
        if (child.data !== next) { patches.set(child, { original: child.data, value: next }); child.data = next; }
      }
    }
    function note(anchor, value) {
      if (!anchor || !value) return;
      var node = doc.createElement('p'); node.className = 'track123_body trlab-tracking-note'; node.textContent = value;
      anchor.after(node); notices.push(node);
    }
    // 仅补充已有节点的含义；不新增物流事件、不改原时间或 React 文本节点。
    function nodeDetail(node, row, kind, sourceCopy) {
      var copy = sourceCopy || NODE_DETAILS[kind];
      if (!row || !copy) return false;
      var description = nodeDetails.get(node);
      if (!description) {
        description = doc.createElement('p');
        description.className = 'track123_body trlab-tracking-node-detail';
        nodeDetails.set(node, description);
      }
      if (description.textContent !== copy) description.textContent = copy;
      var time = node.parentElement.querySelector('.track123_track_time');
      // 保留已插入说明，避免每次观察回调都移除重插导致滚动锚点或点击位置变化。
      var anchor = time || node;
      if (anchor.nextElementSibling !== description) anchor.after(description);
      return true;
    }
    function shopDate(node, at) {
      if (node && order && order.offset !== null && at != null) text(node, preparationDate(at, order.offset));
    }
    function formatTimeline(wrapper) {
      var details = wrapper.querySelector('.track123_order_desc_container');
      if (!details) return;
      // 已匹配事件先换算店铺日期；未知时间仅收起时分秒，销毁时恢复原文。
      details.querySelectorAll('.track123_track_time').forEach(function (node) {
        var value = node.textContent.trim().replace(/\s+\d{1,2}:\d{2}(?::\d{2})?(?:\s*[ap]\.?m\.?)?\s*$/i, '');
        if (value) text(node, value);
      });
      // 原生事件与后台自定义节点共用一条倒序时间线，只有首个可见节点高亮。
      var rows = Array.from(details.querySelectorAll('.track123_order_tracking_detail_style2_item_content, .track123_track_li')).filter(function (node) {
        return !node.closest('[data-trlab-tracking-hidden="true"]') && !node.hidden && win.getComputedStyle(node).display !== 'none';
      });
      rows.forEach(function (node, index) {
        node.setAttribute('data-trlab-timeline-row', (index === 0 ? 'latest ' : '') + (index === rows.length - 1 ? 'last' : 'history'));
        timelineRows.add(node);
      });
    }
    function renderPreparation(wrapper, pack, descriptions) {
      var plan = preparationPlan(order, pack, Date.now());
      var rowSelector = '.track123_order_tracking_detail_style2_item_content, .track123_track_li';
      var ordered = descriptions.find(function (node) { return /^Ordered$/i.test(node.textContent.trim()); });
      var anchor = ordered && ordered.closest(rowSelector);
      // 缺少原生下单锚点时保留原页面，避免跨容器或新结果尚未渲染时错插历史。
      if (plan === null || !anchor) {
        preparationNodes.forEach(function (node) { node.remove(); }); preparationNodes.clear();
        preparationDates.forEach(function (node) { node.remove(); }); preparationDates.clear();
        return new Set();
      }
      var backend = new Set(), copies = {};
      descriptions.forEach(function (node) {
        var kind = preparationKind(node.textContent);
        if (!kind) return;
        backend.add(node); hide(node.closest(rowSelector));
        if (/^Our /i.test(node.textContent.trim())) copies[kind] = node.textContent.trim();
      });
      var keep = new Set();
      plan.forEach(function (stage) {
        var row = preparationNodes.get(stage.key);
        if (!row) {
          row = doc.createElement('div'); row.className = 'track123_track_li trlab-tracking-preparation-node';
          row.dataset.preparation = stage.key;
          ['track123_track_desc track123_body', 'track123_track_time track123_body', 'track123_body trlab-tracking-node-detail'].forEach(function (className, i) {
            var child = doc.createElement(i === 2 ? 'p' : 'div'); child.className = className; row.appendChild(child);
          });
          preparationNodes.set(stage.key, row);
        }
        var values = [stage.title, preparationDate(stage.at, order.offset), preparationCopy(stage.key, copies[stage.key] || stage.copy)];
        values.forEach(function (value, i) { if (row.children[i].textContent !== value) row.children[i].textContent = value; });
        if (row.nextElementSibling !== anchor) anchor.before(row);
        anchor = row; keep.add(stage.key);
      });
      preparationNodes.forEach(function (node, key) { if (!keep.has(key)) { node.remove(); preparationNodes.delete(key); } });
      // 顶部相同的两个自定义阶段同步日期；订单、面单和承运商进度时间保持原值。
      var dateAnchors = new Set();
      wrapper.querySelectorAll('.track123_order_step_line_status_name').forEach(function (node) {
        var kind = preparationKind(node.textContent);
        if (!kind) return;
        var time = node.parentElement.querySelector('.track123_order_step_line_time:not(.trlab-tracking-preparation-date)');
        var stage = plan.find(function (item) { return item.key === kind; });
        hide(time);
        if (!stage) return;
        var date = preparationDates.get(node);
        if (!date) {
          date = doc.createElement('div'); date.className = 'track123_order_step_line_time trlab-tracking-preparation-date';
          preparationDates.set(node, date);
        }
        var value = preparationDate(stage.at, order.offset);
        if (date.textContent !== value) date.textContent = value;
        if (node.nextElementSibling !== date) node.after(date);
        dateAnchors.add(node);
      });
      preparationDates.forEach(function (date, node) { if (!dateAnchors.has(node)) { date.remove(); preparationDates.delete(node); } });
      return backend;
    }
    function render() {
      if (!active) return;
      edit(function () {
        restore(true);
        root = doc.getElementById('track123-app');
        var wrapper = root && root.querySelector('.track123_order_wrapper');
        if (!wrapper) { restore(); return; }
        var renderedNodes = new Set();
        root.setAttribute('data-trlab-tracking-active', 'true');
        var currentTab = wrapper.querySelector('.track123_order_select_active_item') || wrapper.querySelector('.track123_order_tab_item_active');
        var indexMatch = currentTab && currentTab.textContent.match(/#\s*(\d+)/);
        var selected = indexMatch ? Number(indexMatch[1]) - 1 : 0;
        var pack = order && order.packages[selected];
        var header = wrapper.querySelector('.track123_order_header');
        if (order && order.packages.length > 1) note(header, 'Your order ships in ' + order.packages.length + ' packages. They may arrive separately.');
        var status = wrapper.querySelector('.track123_order_status');
        var label = pack ? statusLabel(pack, order.country) : '';
        if (label === 'Label created — awaiting carrier pickup') label = 'Shipped – awaiting carrier pickup';
        if (label) text(status, label);
        var statusContainer = wrapper.querySelector('.track123_order_status_container');
        var edd = pack && estimate(order, pack, Date.now());
        if (edd) {
          hide(wrapper.querySelector('.track123_order_arrive_time'));
          note(statusContainer, (edd.overdue ? 'Original estimated delivery: ' : 'Estimated delivery: ') + calendar(edd.start) + ' – ' + calendar(edd.end));
        }
        if (pack && stale(pack, Date.now())) note(statusContainer, 'No carrier updates for over 5 days. Please contact us for an update.');
        wrapper.querySelectorAll('.track123_order_step_line_status_name').forEach(function (node) {
          var name = node.textContent.trim().toLowerCase().replace(/\s+/g, '_');
          var sourceStatus = pack && pack.statuses.find(function (s) { return s.name.replace(/\s+/g, '_') === name; });
          var at = name === 'ordered' && order ? order.createdAt : sourceStatus && sourceStatus.at;
          shopDate(node.parentElement.querySelector('.track123_order_step_line_time'), at);
          if (/^Order Ready$/i.test(node.textContent.trim())) {
            text(node, 'Preparing your order');
          }
          if (/^In Transit$/i.test(node.textContent.trim()) && /awaiting carrier pickup/.test(label)) text(node, 'Awaiting pickup');
        });
        var descriptions = Array.from(wrapper.querySelectorAll('.track123_track_desc')).filter(function (node) { return !node.closest('.trlab-tracking-preparation-node'); });
        var backendPreparation = renderPreparation(wrapper, pack, descriptions);
        var visibleEvents = pack ? timeline(pack, order.country) : [];
        var seen = {};
        descriptions.slice().reverse().forEach(function (node) {
          if (backendPreparation.has(node)) return;
          var raw = node.textContent, cleaned = clean(raw);
          var row = node.closest('.track123_order_tracking_detail_style2_item_content, .track123_track_li');
          var nativeTime = node.parentElement.querySelector('.track123_track_time');
          var matched = matchEvent(pack, raw, nativeTime && nativeTime.textContent);
          var prepKind = preparationKind(raw);
          var prepStatus = pack && prepKind && pack.statuses.find(function (s) { return preparationKind(s.name) === prepKind; });
          var sourceAt = /^Ordered$/i.test(cleaned) && order ? order.createdAt : prepStatus ? prepStatus.at : matched && matched.utc;
          shopDate(nativeTime, sourceAt);
          // 后台把自定义说明作为事件标题输出：保留正文与日期，仅拆成标题→日期→正文。
          var preparation = /^Our designer partners help prepare your items\b/i.test(raw.trim()) ? 'Designer preparation' :
            /^Our warehouse team prepares your items\b/i.test(raw.trim()) ? 'Warehouse preparation' : '';
          if (preparation) {
            text(node, preparation);
            if (nodeDetail(node, row, '', preparationCopy(preparationKind(raw), raw.trim()))) renderedNodes.add(node);
            return;
          }
          if (/^(?:Designer preparation|Warehouse preparation)$/i.test(raw.trim())) return;
          var kind = matched ? matched.kind : classify(raw);
          var exception = kind === 'exception' || EXCEPTION.test(raw);
          var domestic = matched && (matched.domestic || matched.tail);
          var originWord = /\b(?:Nancheng|Dongguan|Shenzhen|Hong\s*Kong|HK|Mainland\s+China|China|CN|Guangzhou)\b/i.test(raw);
          var knownOrigin = /origin facility|origin international airport|hand(?:ed)? over to airline|export|country of origin/i.test(raw);
          var omitted = matched && !kind && !visibleEvents.some(function (e) { return e.detail === matched.detail && e.utc === matched.utc && e.local === matched.local; });
          if (!exception && ((kind && seen[kind] && !domestic) || (!kind && !domestic && (originWord || knownOrigin || omitted)))) { hide(row); return; }
          if (kind) seen[kind] = true;
          var labels = { label: 'Label created', picked: 'Picked up by carrier', departed: 'Departed origin', arrived: order && order.country === 'US' ? 'Arrived in US' : 'Arrived at destination' };
          text(node, labels[kind] || cleaned);
          if (nodeDetail(node, row, kind === 'label' ? 'label' : /^Ordered$/i.test(cleaned) ? 'ordered' : '')) renderedNodes.add(node);
        });
        nodeDetails.forEach(function (description, node) {
          if (!renderedNodes.has(node)) { description.remove(); nodeDetails.delete(node); }
        });
        formatTimeline(wrapper);
        wrapper.querySelectorAll('.track123_order_last_tracking_detail').forEach(function (node) { text(node, clean(node.textContent)); });
        wrapper.querySelectorAll('.track123_order_tracing_no, .track123_tracking_number').forEach(function (node) {
          if (/\b(?:4PX[0-9A-Z]+|UL[0-9A-Z]+YP|YT\d{8,})\b/i.test(node.textContent)) hide(node);
        });
        wrapper.querySelectorAll('.track123_order_courier_info_content').forEach(function (node) {
          var name = node.querySelector('.track123_carrier_info_name');
          if (name && !/^USPS$/i.test(name.textContent.trim())) { hide(name); hide(node.querySelector('.track123_order_courier_img_box')); }
        });
        wrapper.querySelectorAll('.track123_track_desc_courier').forEach(function (node) { if (!/^USPS$/i.test(node.textContent.trim())) hide(node); });
        root.querySelectorAll('.track123_product_recommendations_wrapper, .track123_product_recommendation_container').forEach(hide);
      });
    }
    function schedule() {
      if (scheduled || !active) return;
      scheduled = true;
      win.requestAnimationFrame(function () { scheduled = false; try { render(); } catch (_) { clear(); } });
    }
    function matches(input) {
      try {
        var url = new URL(typeof input === 'string' || input instanceof URL ? String(input) : input.url, win.location.href);
        return url.origin === 'https://shp.track123.com' && url.pathname === ENDPOINT;
      } catch (_) { return false; }
    }
    function wrappedFetch(input, init) {
      if (!active || !matches(input)) return originalFetch.apply(this, arguments);
      var seq = ++revision; clear(); schedule();
      var result = originalFetch.apply(this, arguments);
      result.then(function (response) {
        if (!active || seq !== revision || !response.ok) return;
        response.clone().json().then(function (raw) {
          if (!active || seq !== revision) return;
          order = normalize(raw); schedule();
        }).catch(function () {});
      }, function () {}).catch(function () {});
      return result;
    }
    win.fetch = wrappedFetch;
    observer = new MutationObserver(schedule);
    function ready() { observe(); schedule(); }
    // 到达 23/45 小时门槛时显示固定准备记录；有真实面单后时间固定，不按访问日期漂移。
    var clockTimer = win.setInterval(schedule, 60000);
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
    win.__trlabTrackingDisplay = {
      version: 'track123-native-v13',
      destroy: function () {
        active = false; revision++; if (observer) observer.disconnect(); restore(); order = null;
        win.clearInterval(clockTimer);
        doc.removeEventListener('DOMContentLoaded', ready);
        if (win.fetch === wrappedFetch) win.fetch = originalFetch;
      }
    };
  }

  return { matchEvent: matchEvent, preparationDate: preparationDate, clean: clean, instant: instant, normalize: normalize, preparationPlan: preparationPlan, timeline: timeline, statusLabel: statusLabel, estimate: estimate, stale: stale, eventTime: eventTime, start: start };
});
